import React from 'react';

const BacksolveContext = React.createContext({});

export default BacksolveContext;
